var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"claim-title-block"},[_c('h4',{staticClass:"claim-title-text"},[_vm._t("default")],2),(_vm.$slots.hint)?_c('p',{staticClass:"claim-title-hint"},[_vm._t("hint")],2):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }